import { createRouter, createWebHistory } from "vue-router";
import { queryClient } from "@/libs/queryClient";
import LoginView from "@/views/LoginView.vue";
import DashboardView from "@/views/dashboard/DashboardView.vue";
import PatientListView from "@/views/patients/PatientListView.vue";
import ProductListView from "@/views/products/ProductListView.vue";
import PatientRecordView from "@/views/patients/PatientRecordView.vue";
import ProductRecordView from "@/views/products/ProductRecordView.vue";
import TicketListView from "@/views/tickets/TicketListView.vue";
import TicketRecordView from "@/views/tickets/TicketRecordView.vue";
import ReceivableListView from "@/views/receivables/ReceivableListView.vue";
import PaymentListView from "@/views/payments/PaymentListView.vue";

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: DashboardView
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView
  },
  {
    path: '/patients',
    name: 'Patient List',
    component: PatientListView
  },
  {
    path: '/patients/:id/:tab?',
    name: 'Patient Details',
    component: PatientRecordView
  },
  {
    path: '/tickets',
    name: 'Ticket List',
    component: TicketListView
  },
  {
    path: '/tickets/:id/:tab?',
    name: 'Ticket Details',
    component: TicketRecordView
  },
  {
    path: '/products',
    name: 'Product List',
    component: ProductListView
  },
  {
    path: '/products/:id/:tab?',
    name: 'Product Details',
    component: ProductRecordView
  },
  {
    path: '/receivables',
    name: 'Receivable List',
    component: ReceivableListView
  },
  {
    path: '/payments',
    name: 'Payment List',
    component: PaymentListView
  },
]

const router = createRouter({
  routes: routes,
  history: createWebHistory()
})

let authVerified = false

router.beforeEach(async (to) => {
  if (to.path === '/login' || to.path === '/') {
    authVerified = false
    queryClient.removeQueries({ queryKey: ['user'] })
    return true
  }

  if (authVerified) return true

  try {
    const res = await fetch(process.env.VUE_APP_API + '/auth/me', {
      credentials: 'include'
    })
    if (res.ok) {
      const data = await res.json()
      queryClient.setQueryData(['user'], data.user)
      authVerified = true
      return true
    }
    return '/login'
  } catch {
    return '/login'
  }
})

export default router;